import React from 'react'

export const NotFound = () => {
  return (
    <div className='vh-100 fs-6 vw-100 text-grey d-flex justify-content-center align-items-center'>Page Not Found</div>
  )
}
